import { uniqBy } from 'lodash';

import { mapStringToPhrasesSelectorListItem } from '../../mappers/phrasesSelectorWizard';
import { KeyCode } from '../../typings/common';
import {
    KeywordsStatDictionary,
    PhrasesSelectorListItem
} from '../../typings/phrases';

export function mergeAndSortSelectorListItems(
    lists: PhrasesSelectorListItem[][]
): PhrasesSelectorListItem[] {
    return uniqBy(lists.reduce((acc, el) => acc.concat(el), []), 'text').sort(
        (a: PhrasesSelectorListItem, b: PhrasesSelectorListItem) =>
            b.shows - a.shows
    );
}

export function getKeywordStatPhrases(
    startPhrases: PhrasesSelectorListItem[],
    chosenPhrases: PhrasesSelectorListItem[],
    keywordsStat: KeywordsStatDictionary
): {
    similarPhrases: PhrasesSelectorListItem[];
    searchedAlsoPhrases: PhrasesSelectorListItem[];
} {
    const selectedStartPhrases = startPhrases.filter(el => el.selected);
    const chosenPhrasesSet = new Set<string>(chosenPhrases.map(el => el.text));

    const similarPhrases = mergeAndSortSelectorListItems(
        selectedStartPhrases.map(({ text }) =>
            keywordsStat[text].searchedWith.filter(
                el => !chosenPhrasesSet.has(el.text)
            )
        )
    ).map(el => ({ ...el, selected: false }));

    const searchedAlsoPhrases = mergeAndSortSelectorListItems(
        selectedStartPhrases.map(({ text }) =>
            keywordsStat[text].searchedAlso.filter(
                el => !chosenPhrasesSet.has(el.text)
            )
        )
    ).map(el => ({ ...el, selected: false }));

    return {
        similarPhrases,
        searchedAlsoPhrases
    };
}

export function getNewMinusWordsList(
    startPhrases: PhrasesSelectorListItem[],
    oldMinusWords: PhrasesSelectorListItem[],
    newMinusWords: PhrasesSelectorListItem[]
): PhrasesSelectorListItem[] {
    const excludedWords = new Set<string>(
        [...oldMinusWords, ...startPhrases].map(el => el.text)
    );

    const minusWords = newMinusWords
        .filter(el => !excludedWords.has(el.text))
        .map(el => mapStringToPhrasesSelectorListItem(el.text));

    return minusWords.reduce((acc, el) => [...acc, el], oldMinusWords);
}

export function getNewChosenWordsList(
    oldChosenPhrases: PhrasesSelectorListItem[],
    newChosenPhrases: PhrasesSelectorListItem[]
): PhrasesSelectorListItem[] {
    const excludedWords = new Set<string>(oldChosenPhrases.map(el => el.text));

    return [
        ...oldChosenPhrases,
        ...newChosenPhrases.filter(el => !excludedWords.has(el.text))
    ];
}

export function processSelection(
    items: PhrasesSelectorListItem[],
    indexOfClick: number,
    indexOfPreviousClick: number,
    keyCode?: KeyCode
): Array<boolean> {
    return items.map((el, index) => {
        switch (keyCode) {
            case KeyCode.CTRL:
                return indexOfClick === index ? !el.selected : el.selected;
            case KeyCode.SHIFT:
                if (indexOfPreviousClick <= indexOfClick) {
                    return (
                        index <= indexOfClick && index >= indexOfPreviousClick
                    );
                } else {
                    return (
                        index >= indexOfClick && index <= indexOfPreviousClick
                    );
                }
            default:
                return indexOfClick === index;
        }
    });
}
